import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { SearchBox } from 'fw/forms';
import { StatusFilter, CertificationTooltipCategoryCombo } from 'areas/shared/controls';
import { SetupSearch } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API'

class Search extends SetupSearch {
    
    initialForm() {
        return {
            searchText: "",
            stepCode: "",
            statusFilter: true,
        };
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    searchLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: {
                type: 'tooltip'
            }
        }
    }

    renderForm() {
        return (
            <Row>
                <Col md={3}>
                    <SearchBox
                        name="searchText"
                        label="searchText"
                        placeholder="Search tooltip..."
                        loader={this.searchLoader}
                        ref={(c) => { this.focusControl = c }} />
                </Col>
                <Col md={3}>
                    <CertificationTooltipCategoryCombo
                        name="categoryCode"
                        placeholder="Step..."
                        onChange={this.search}
                        clearable
                    />
                </Col>
                <Col md={2}>
                    <StatusFilter name="statusFilter" onChange={this.search} entity="tooltips" />
                </Col>
            </Row>
        )
    }
}

export default Search;


// WEBPACK FOOTER //
// ./src/areas/admin/tooltipManagerSetup/Search.js